import { BiCodeAlt } from "react-icons/bi";
import { IoBrushOutline } from "react-icons/io5";
import { SiEthereum } from "react-icons/si";
import { FaServer, FaLaptopCode } from "react-icons/fa";

export const SkillSet = [
  // Blockchain
  {
    id: "1",
    name: "Rust",
    imgsrc: "images/rust.svg",
    category: "blockchain",
  },
  {
    id: "2",
    name: "Solidity",
    imgsrc: "images/solidity.png",
    category: "blockchain",
  },
  {
    id: "3",
    name: "Go",
    imgsrc: "images/go.svg",
    category: "blockchain",
  },
  {
    id: "4",
    name: "Python",
    imgsrc: "images/python.png",
    category: "blockchain",
  },
  {
    id: "5",
    name: "C++",
    imgsrc: "images/C++.png",
    category: "blockchain",
  },
  {
    id: "6",
    name: "Web3.js",
    imgsrc: "images/web3.png",
    category: "blockchain",
  },
  {
    id: "7",
    name: "Ethereum",
    imgsrc: "images/ethereum.png",
    category: "blockchain",
  },
  {
    id: "8",
    name: "Solana",
    imgsrc: "images/solana.png",
    category: "blockchain",
  },
  {
    id: "9",
    name: "TON",
    imgsrc: "images/ton.png",
    category: "blockchain",
  },
  // Backend
  {
    id: "10",
    name: "Node Js",
    imgsrc: "images/nodejs.png",
    category: "backend",
  },
  {
    id: "11",
    name: "NestJS",
    imgsrc: "images/nestjs.svg",
    category: "backend",
  },
  {
    id: "12",
    name: "Django",
    imgsrc: "images/django.png",
    category: "backend",
  },
  {
    id: "13",
    name: "FastAPI",
    imgsrc: "images/fastapi.png",
    category: "backend",
  },
  {
    id: "14",
    name: "Express",
    imgsrc: "images/express.png",
    category: "backend",
  },
  {
    id: "15",
    name: "Supabase",
    imgsrc: "images/supabase.png",
    category: "backend",
  },
  {
    id: "16",
    name: "PostgreSQL",
    imgsrc: "images/postgresql.svg",
    category: "backend",
  },
  {
    id: "17",
    name: "MongoDB",
    imgsrc: "images/mongodb.png",
    category: "backend",
  },
  {
    id: "18",
    name: "MySQL",
    imgsrc: "images/mysql.png",
    category: "backend",
  },
  // Frontend
  {
    id: "19",
    name: "ReactJs",
    imgsrc: "images/React.png",
    category: "frontend",
  },
  {
    id: "20",
    name: "Next Js",
    imgsrc: "images/Nextjs-logo.svg",
    category: "frontend",
  },
  {
    id: "21",
    name: "Vue",
    imgsrc: "images/vue.png",
    category: "frontend",
  },
  {
    id: "22",
    name: "Nuxt",
    imgsrc: "images/nuxtjs.png",
    category: "frontend",
  },
  {
    id: "23",
    name: "TypeScript",
    imgsrc: "images/typescript.png",
    category: "frontend",
  },
  {
    id: "24",
    name: "Javascript",
    imgsrc: "images/javascript.png",
    category: "frontend",
  },
  {
    id: "25",
    name: "HTML 5",
    imgsrc: "images/HTML5.png",
    category: "frontend",
  },
  {
    id: "26",
    name: "CSS 3",
    imgsrc: "images/CSS3.png",
    category: "frontend",
  },
  {
    id: "27",
    name: "Bootstrap",
    imgsrc: "images/Bootstrap.png",
    category: "frontend",
  },
  {
    id: "28",
    name: "Material-ui",
    imgsrc: "images/Material-ui.png",
    category: "frontend",
  },
  {
    id: "29",
    name: "Sass",
    imgsrc: "images/SASS.png",
    category: "frontend",
  },
];

export const ProjImg = [
  {
    id: "1",
    name: "OneDex",
    category: "blockchain",
    imgsrc: "projectImg/blockchain/onedex.png",
    href: "https://swap.onedex.app/",
  },
  {
    id: "2",
    name: "SimpleNft",
    category: "blockchain",
    imgsrc: "projectImg/blockchain/simplenft.png",
    href: "https://app.simplenft.io",
  },
  {
    id: "3",
    name: "Streamflow",
    category: "blockchain",
    imgsrc: "projectImg/blockchain/stream-flow.png",
    href: "https://streamflow.finance/",
  },
  {
    id: "4",
    name: "Minted",
    category: "blockchain",
    imgsrc: "projectImg/blockchain/minted_network.png",
    href: "https://minted.network/",
  },
  {
    id: "5",
    name: "Solana Monkey",
    category: "blockchain",
    imgsrc: "projectImg/blockchain/solana_monkey.png",
    href: "https://solanamonkey.business/",
  },
  {
    id: "6",
    name: "Vorpal",
    category: "blockchain",
    imgsrc: "projectImg/blockchain/vorpal.png",
    href: "https://webgl.hidrona.com/",
  },
  {
    id: "7",
    name: "Saturday Quiz",
    category: "fullstack",
    imgsrc: "projectImg/fullstack/saturdayquiz.png",
    href: "https://www.saturdayquiztime.com.au/",
  },
  {
    id: "8",
    name: "Coworking",
    category: "fullstack",
    imgsrc: "projectImg/fullstack/coworking.png",
    href: "https://coworking-theme.pages.dev/",
  },
  {
    id: "9",
    name: "Orbit",
    category: "fullstack",
    imgsrc: "projectImg/fullstack/orbit.png",
    href: "https://orbit-portfolio.vercel.app/",
  },
  {
    id: "10",
    name: "Game Hub",
    category: "fullstack",
    imgsrc: "projectImg/fullstack/game-hub.png",
    href: "https://game-hub-jet-three.vercel.app/",
  },
];
export const Experience = [
  {
    id: "1",
    date: "Sep 2021 - Mar 2022",
    name: "Graphic Designer",
    company: "Dharaksha Ecosolutions",
    desc: [
      "Collaborate with social media teams.",
      "Design and update website.",
      "Design different media post on Instagram.",
    ],
  },
  {
    id: "2",
    date: "Feb 2020 - Present",
    name: "Digital Artist",
    company: "",
    desc: ["Self-taught digital artist on instagram"],
  },
];
export const Education = [
  {
    id: 1,
    date: "Dec 2020-Present",
    name: "Maharaja Agrasen Institute of Technology",
    company: "Rohini Sec-22, Delhi-86",
    desc: "Btech Degree in Electrical and Electronic Engineering Maharaja Agrasen Institute of Technology, Rohini, Delhi",
  },
  {
    id: 2,
    date: "Aug 2019 - Mar 2020",
    name: "Graphic Design Course",
    company: "DICS, GTB Nagar",
    desc: "Completed Graphic Design course",
  },
  {
    id: 3,
    date: "2018-2019",
    name: "XIIth",
    company: "Govt Boys Sr Sec School No-2 Roop Nagar Delhi",
    desc: "",
  },
];
export const Services = [
  {
    id: 1,
    icon: <SiEthereum />,
    name: "Smart Contract Development",
    desc: "Build secure and audited smart contracts for DeFi, NFTs, DAOs, and custom blockchain solutions",
  },
  {
    id: 2,
    icon: <BiCodeAlt />,
    name: "Web3 DApp Development",
    desc: "Create full-stack decentralized applications with seamless blockchain integration",
  },
  {
    id: 3,
    icon: <FaServer />,
    name: "Backend & API Development",
    desc: "Design scalable backend systems, microservices, and RESTful/GraphQL APIs",
  },
  {
    id: 4,
    icon: <FaLaptopCode />,
    name: "Frontend Development",
    desc: "Build modern, responsive user interfaces with React, Next.js, and cutting-edge web technologies",
  },
];
